(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["madar-dice-card"] && !Shopify.designMode) return;
  try {
    if(!customElements.get('madar-dice-card'))customElements.define('madar-dice-card',class extends HTMLElement{
 connectedCallback(){
  if(this.ready)return;
  this.ready=true;
  this.variants=JSON.parse(this.querySelector('[data-variants]').textContent);
  this.select=this.querySelector('select[name=id]');
  this.add=this.querySelector('[name=add]');
  this.select.addEventListener('change',()=>this.update(this.variants.find(v=>String(v.id)===this.select.value)));
  this.querySelectorAll('[data-colour]').forEach(button=>button.addEventListener('click',()=>{
   const previous=this.variants.find(v=>String(v.id)===this.select.value);
   const matches=this.variants.filter(v=>v.colour===button.dataset.colour);
   const selected=previous&&matches.find(v=>v.size===previous.size);
   for(const option of this.select.options){const variant=this.variants.find(v=>String(v.id)===option.value);option.hidden=Boolean(variant&&variant.colour!==button.dataset.colour);}
   if(selected){this.update(selected);return;}
   this.select.value='';
   this.add.disabled=true;
   this.add.textContent=this.dataset.choose;
   this.querySelector('[data-availability]').textContent=this.dataset.prompt;
   this.querySelectorAll('[data-colour]').forEach(b=>b.setAttribute('aria-pressed',String(b===button)));
   this.querySelectorAll('[data-product-link]').forEach(a=>{const u=new URL(a.href);u.searchParams.delete('variant');a.href=u.href;});
  }));
  this.querySelector('form').addEventListener('submit',e=>{const selected=this.variants.find(v=>String(v.id)===this.select.value);if(!selected?.available){e.preventDefault();this.select.reportValidity();}});
 }
 update(v){
  if(!v)return;
  this.select.value=String(v.id);
  this.add.disabled=!v.available;
  this.add.textContent=v.available?this.dataset.add:this.dataset.sold;
  const status=this.querySelector('[data-availability]');
  status.textContent=v.status;
  status.dataset.sold=String(!v.available);
  this.querySelector('[data-price]').textContent=v.price;
  this.querySelectorAll('[data-colour]').forEach(b=>b.setAttribute('aria-pressed',String(b.dataset.colour===v.colour)));
  const image=this.querySelector('.md-dice-card__photo img');
  if(image&&v.image){image.removeAttribute('srcset');image.src=v.image;image.alt=this.querySelector('h3').textContent+' — '+v.colour;}
  this.querySelectorAll('[data-product-link]').forEach(a=>{const u=new URL(a.href);u.searchParams.set('variant',v.id);a.href=u.href;});
 }
});
  } catch(e) { console.error(e); }
})();

})();
